<template>
  <v-col class="ma-0 pa-0 transparent mt-2" cols="12">
    <div class="my-breadcrumbs">
      <ul>
        <li v-for="(crumb, index) in breadcrumbItems" :key="index">
          <span
            @click.prevent="navigate(index)"
            class="vetalfa-subtitle vetalfa-pointer"
          >
            {{ crumb.text }}
          </span>
          <v-icon
            v-if="index < breadcrumbItems.length - 1"
            class="ma-0 pa-0"
            small
            >{{ mdiChevronRight }}</v-icon
          >
        </li>
      </ul>
    </div>
  </v-col>
</template>

<script>
import { mdiChevronRight } from "@mdi/js";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  computed: {
    ...mapGetters("general", ["breadcrumbs"]),
    ...mapState("general", ["routeCount"]),
    breadcrumbItems() {
      return this.breadcrumbs.map((crumb) => ({
        text: crumb.name,
        href: crumb.path,
      }));
    },
  },
  data() {
    return {
      mdiChevronRight,
    };
  },
  methods: {
    ...mapActions("general", ["pushOrPopRouteOfBreadcrumb", "routeBack"]),
    navigate(index) {
      if (index + 1 == this.breadcrumbs.length) {
        return;
      }
      const stepsBack = this.breadcrumbs.length - 1 - index;
      this.pushOrPopRouteOfBreadcrumb({ offset: stepsBack }).then(() => {
        if (this.routeCount == 1) {
          return this.routeBack();
        }
        this.$router.go(-stepsBack);
      });
    },
  },
};
</script>

<style scoped>
.my-breadcrumbs ul {
  list-style-type: none;
  padding: 0;
}

.my-breadcrumbs li {
  display: inline;
}

.my-breadcrumbs li:nth-child(even) {
  padding: 0 4px !important;
}
</style>